
export enum TransitTimeDirectionTypeCd {
	BOTH = 'Both',
	INBOUND = 'Inbound',
	OUTBOUND = 'Outbound'}

